
import './App.css';
import Routing from './Pages/Routing';
import Navbar from './Components/Navbar';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routing/>
    </div>
  );
}

export default App;